module.exports = __webpack_public_path__ + "static/clients-jurishand-b4eb9873be3e6f38d898e94310bac5f2.svg";